import { useState } from 'react';
import type { Space } from '../../../models';

function useSpaceOptions(spaceOptions: Space[]) {
  const [searchText, setSearchText] = useState('');

  const filteredOptions = spaceOptions.filter((option) =>
    option.spaceName.toLowerCase().includes(searchText.toLowerCase()),
  );

  return { filteredOptions, searchText, setSearchText };
}

export { useSpaceOptions };
